var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_469)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_503_469",
    maskUnits: "userSpaceOnUse",
    x: -0.73877,
    y: -0.447266,
    width: 27,
    height: 27,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -0.73877,
    y: -0.447266,
    width: 27,
    height: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1743 11.3354C24.0748 8.49939 22.9263 5.84739 20.9097 3.83077C18.796 1.71664 15.9868 0.552734 13 0.552734C6.96761 0.552734 2.03857 5.3542 1.82611 11.3354C0.905543 11.7445 0.26123 12.6659 0.26123 13.7368V16.687C0.26123 18.1356 1.43976 19.3146 2.88886 19.3146C3.82648 19.3146 4.58901 18.552 4.58901 17.6144V12.8089C4.58901 11.9285 3.91382 11.2107 3.05542 11.1254C3.37229 5.91442 7.71023 1.77148 13 1.77148C15.6618 1.77148 18.1647 2.80905 20.0484 4.69283C21.7783 6.42264 22.7906 8.67733 22.943 11.1258C22.0854 11.2119 21.4114 11.9294 21.4114 12.8089V17.614C21.4114 18.5017 22.0972 19.224 22.9657 19.2991V20.5134C22.9657 21.8809 21.853 22.9932 20.4856 22.9932H18.6489C18.5587 22.7356 18.4174 22.4975 18.2191 22.3001C17.8718 21.9511 17.4086 21.759 16.9154 21.759H15.0223C14.7505 21.759 14.4897 21.8167 14.2509 21.928C13.5992 22.2274 13.1784 22.8847 13.1784 23.6025C13.1784 24.0957 13.3705 24.5589 13.7187 24.9054C14.0668 25.2544 14.5299 25.4465 15.0223 25.4465H16.9154C17.7003 25.4465 18.3922 24.9391 18.6501 24.2119H20.4856C22.5254 24.2119 24.1845 22.5528 24.1845 20.5134V19.0822C25.0994 18.6707 25.7388 17.7525 25.7388 16.6861V13.736C25.7388 12.6659 25.0945 11.7445 24.1743 11.3354ZM3.36986 12.8089V17.614C3.36986 17.8793 3.15414 18.0954 2.88845 18.0954C2.1117 18.0954 1.47957 17.4633 1.47957 16.6865V13.7364C1.47957 12.9592 2.1117 12.3275 2.88845 12.3275C3.15414 12.3275 3.36986 12.5436 3.36986 12.8089ZM17.5269 23.7334C17.4663 24.0202 17.2088 24.2286 16.915 24.2286H15.0219C14.8554 24.2286 14.6989 24.1636 14.5795 24.0441C14.4617 23.9267 14.3967 23.7699 14.3967 23.6034C14.3967 23.36 14.5393 23.1378 14.7627 23.035C14.8424 22.9976 14.9297 22.9785 15.0219 22.9785H16.915C17.0816 22.9785 17.238 23.0431 17.357 23.1626C17.4749 23.28 17.5399 23.4368 17.5399 23.6034C17.5403 23.648 17.5354 23.6927 17.5269 23.7334ZM24.52 16.6865C24.52 17.4633 23.8879 18.0954 23.1112 18.0954C22.8459 18.0954 22.6298 17.8797 22.6298 17.614V12.8089C22.6298 12.5436 22.8455 12.3275 23.1112 12.3275C23.8879 12.3275 24.52 12.9596 24.52 13.7364V16.6865Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.1743 11.3354C24.0748 8.49939 22.9263 5.84739 20.9097 3.83077C18.796 1.71664 15.9868 0.552734 13 0.552734C6.96761 0.552734 2.03857 5.3542 1.82611 11.3354C0.905543 11.7445 0.26123 12.6659 0.26123 13.7368V16.687C0.26123 18.1356 1.43976 19.3146 2.88886 19.3146C3.82648 19.3146 4.58901 18.552 4.58901 17.6144V12.8089C4.58901 11.9285 3.91382 11.2107 3.05542 11.1254C3.37229 5.91442 7.71023 1.77148 13 1.77148C15.6618 1.77148 18.1647 2.80905 20.0484 4.69283C21.7783 6.42264 22.7906 8.67733 22.943 11.1258C22.0854 11.2119 21.4114 11.9294 21.4114 12.8089V17.614C21.4114 18.5017 22.0972 19.224 22.9657 19.2991V20.5134C22.9657 21.8809 21.853 22.9932 20.4856 22.9932H18.6489C18.5587 22.7356 18.4174 22.4975 18.2191 22.3001C17.8718 21.9511 17.4086 21.759 16.9154 21.759H15.0223C14.7505 21.759 14.4897 21.8167 14.2509 21.928C13.5992 22.2274 13.1784 22.8847 13.1784 23.6025C13.1784 24.0957 13.3705 24.5589 13.7187 24.9054C14.0668 25.2544 14.5299 25.4465 15.0223 25.4465H16.9154C17.7003 25.4465 18.3922 24.9391 18.6501 24.2119H20.4856C22.5254 24.2119 24.1845 22.5528 24.1845 20.5134V19.0822C25.0994 18.6707 25.7388 17.7525 25.7388 16.6861V13.736C25.7388 12.6659 25.0945 11.7445 24.1743 11.3354ZM3.36986 12.8089V17.614C3.36986 17.8793 3.15414 18.0954 2.88845 18.0954C2.1117 18.0954 1.47957 17.4633 1.47957 16.6865V13.7364C1.47957 12.9592 2.1117 12.3275 2.88845 12.3275C3.15414 12.3275 3.36986 12.5436 3.36986 12.8089ZM17.5269 23.7334C17.4663 24.0202 17.2088 24.2286 16.915 24.2286H15.0219C14.8554 24.2286 14.6989 24.1636 14.5795 24.0441C14.4617 23.9267 14.3967 23.7699 14.3967 23.6034C14.3967 23.36 14.5393 23.1378 14.7627 23.035C14.8424 22.9976 14.9297 22.9785 15.0219 22.9785H16.915C17.0816 22.9785 17.238 23.0431 17.357 23.1626C17.4749 23.28 17.5399 23.4368 17.5399 23.6034C17.5403 23.648 17.5354 23.6927 17.5269 23.7334ZM24.52 16.6865C24.52 17.4633 23.8879 18.0954 23.1112 18.0954C22.8459 18.0954 22.6298 17.8797 22.6298 17.614V12.8089C22.6298 12.5436 22.8455 12.3275 23.1112 12.3275C23.8879 12.3275 24.52 12.9596 24.52 13.7364V16.6865Z",
    fill: "url(#paint0_linear_503_469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1743 11.3354C24.0748 8.49939 22.9263 5.84739 20.9097 3.83077C18.796 1.71664 15.9868 0.552734 13 0.552734C6.96761 0.552734 2.03857 5.3542 1.82611 11.3354C0.905543 11.7445 0.26123 12.6659 0.26123 13.7368V16.687C0.26123 18.1356 1.43976 19.3146 2.88886 19.3146C3.82648 19.3146 4.58901 18.552 4.58901 17.6144V12.8089C4.58901 11.9285 3.91382 11.2107 3.05542 11.1254C3.37229 5.91442 7.71023 1.77148 13 1.77148C15.6618 1.77148 18.1647 2.80905 20.0484 4.69283C21.7783 6.42264 22.7906 8.67733 22.943 11.1258C22.0854 11.2119 21.4114 11.9294 21.4114 12.8089V17.614C21.4114 18.5017 22.0972 19.224 22.9657 19.2991V20.5134C22.9657 21.8809 21.853 22.9932 20.4856 22.9932H18.6489C18.5587 22.7356 18.4174 22.4975 18.2191 22.3001C17.8718 21.9511 17.4086 21.759 16.9154 21.759H15.0223C14.7505 21.759 14.4897 21.8167 14.2509 21.928C13.5992 22.2274 13.1784 22.8847 13.1784 23.6025C13.1784 24.0957 13.3705 24.5589 13.7187 24.9054C14.0668 25.2544 14.5299 25.4465 15.0223 25.4465H16.9154C17.7003 25.4465 18.3922 24.9391 18.6501 24.2119H20.4856C22.5254 24.2119 24.1845 22.5528 24.1845 20.5134V19.0822C25.0994 18.6707 25.7388 17.7525 25.7388 16.6861V13.736C25.7388 12.6659 25.0945 11.7445 24.1743 11.3354ZM3.36986 12.8089V17.614C3.36986 17.8793 3.15414 18.0954 2.88845 18.0954C2.1117 18.0954 1.47957 17.4633 1.47957 16.6865V13.7364C1.47957 12.9592 2.1117 12.3275 2.88845 12.3275C3.15414 12.3275 3.36986 12.5436 3.36986 12.8089ZM17.5269 23.7334C17.4663 24.0202 17.2088 24.2286 16.915 24.2286H15.0219C14.8554 24.2286 14.6989 24.1636 14.5795 24.0441C14.4617 23.9267 14.3967 23.7699 14.3967 23.6034C14.3967 23.36 14.5393 23.1378 14.7627 23.035C14.8424 22.9976 14.9297 22.9785 15.0219 22.9785H16.915C17.0816 22.9785 17.238 23.0431 17.357 23.1626C17.4749 23.28 17.5399 23.4368 17.5399 23.6034C17.5403 23.648 17.5354 23.6927 17.5269 23.7334ZM24.52 16.6865C24.52 17.4633 23.8879 18.0954 23.1112 18.0954C22.8459 18.0954 22.6298 17.8797 22.6298 17.614V12.8089C22.6298 12.5436 22.8455 12.3275 23.1112 12.3275C23.8879 12.3275 24.52 12.9596 24.52 13.7364V16.6865Z",
    stroke: "url(#paint1_linear_503_469)",
    strokeWidth: 0.4,
    mask: "url(#path-1-outside-1_503_469)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-2_503_469",
    maskUnits: "userSpaceOnUse",
    x: 5.47217,
    y: 5.47119,
    width: 15,
    height: 15,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 5.47217,
    y: 5.47119,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9461 16.8968C18.37 16.8968 19.5282 15.7382 19.5282 14.3147V9.05332C19.5282 8.36513 19.2593 7.71675 18.771 7.22844C18.2827 6.74013 17.6347 6.47119 16.9461 6.47119H9.05429C7.63039 6.47119 6.47217 7.62941 6.47217 9.05332V14.3147C6.47217 15.7386 7.63039 16.8968 9.05429 16.8968H9.10264V18.2602C9.10264 18.7802 9.41261 19.2417 9.89198 19.4363C10.0468 19.4984 10.2076 19.5293 10.3669 19.5293C10.6988 19.5293 11.0222 19.3977 11.259 19.1527L13.5271 16.8968H16.9461ZM12.8466 15.8552L10.3921 18.2963C10.3811 18.3077 10.373 18.3162 10.3498 18.3061C10.3218 18.2947 10.3218 18.2764 10.3218 18.2602V16.2874C10.3218 15.951 10.0492 15.678 9.71242 15.678H9.0547C8.30273 15.678 7.69132 15.0662 7.69132 14.3147V9.05332C7.69132 8.30135 8.30273 7.68994 9.0547 7.68994H16.9465C17.3097 7.68994 17.6514 7.83213 17.9097 8.0901C18.1681 8.34847 18.3099 8.69054 18.3099 9.05332V14.3147C18.3099 15.0666 17.6981 15.678 16.9465 15.678H13.2764C13.1152 15.678 12.9608 15.7418 12.8466 15.8552Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.9461 16.8968C18.37 16.8968 19.5282 15.7382 19.5282 14.3147V9.05332C19.5282 8.36513 19.2593 7.71675 18.771 7.22844C18.2827 6.74013 17.6347 6.47119 16.9461 6.47119H9.05429C7.63039 6.47119 6.47217 7.62941 6.47217 9.05332V14.3147C6.47217 15.7386 7.63039 16.8968 9.05429 16.8968H9.10264V18.2602C9.10264 18.7802 9.41261 19.2417 9.89198 19.4363C10.0468 19.4984 10.2076 19.5293 10.3669 19.5293C10.6988 19.5293 11.0222 19.3977 11.259 19.1527L13.5271 16.8968H16.9461ZM12.8466 15.8552L10.3921 18.2963C10.3811 18.3077 10.373 18.3162 10.3498 18.3061C10.3218 18.2947 10.3218 18.2764 10.3218 18.2602V16.2874C10.3218 15.951 10.0492 15.678 9.71242 15.678H9.0547C8.30273 15.678 7.69132 15.0662 7.69132 14.3147V9.05332C7.69132 8.30135 8.30273 7.68994 9.0547 7.68994H16.9465C17.3097 7.68994 17.6514 7.83213 17.9097 8.0901C18.1681 8.34847 18.3099 8.69054 18.3099 9.05332V14.3147C18.3099 15.0666 17.6981 15.678 16.9465 15.678H13.2764C13.1152 15.678 12.9608 15.7418 12.8466 15.8552Z",
    fill: "url(#paint2_linear_503_469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9461 16.8968C18.37 16.8968 19.5282 15.7382 19.5282 14.3147V9.05332C19.5282 8.36513 19.2593 7.71675 18.771 7.22844C18.2827 6.74013 17.6347 6.47119 16.9461 6.47119H9.05429C7.63039 6.47119 6.47217 7.62941 6.47217 9.05332V14.3147C6.47217 15.7386 7.63039 16.8968 9.05429 16.8968H9.10264V18.2602C9.10264 18.7802 9.41261 19.2417 9.89198 19.4363C10.0468 19.4984 10.2076 19.5293 10.3669 19.5293C10.6988 19.5293 11.0222 19.3977 11.259 19.1527L13.5271 16.8968H16.9461ZM12.8466 15.8552L10.3921 18.2963C10.3811 18.3077 10.373 18.3162 10.3498 18.3061C10.3218 18.2947 10.3218 18.2764 10.3218 18.2602V16.2874C10.3218 15.951 10.0492 15.678 9.71242 15.678H9.0547C8.30273 15.678 7.69132 15.0662 7.69132 14.3147V9.05332C7.69132 8.30135 8.30273 7.68994 9.0547 7.68994H16.9465C17.3097 7.68994 17.6514 7.83213 17.9097 8.0901C18.1681 8.34847 18.3099 8.69054 18.3099 9.05332V14.3147C18.3099 15.0666 17.6981 15.678 16.9465 15.678H13.2764C13.1152 15.678 12.9608 15.7418 12.8466 15.8552Z",
    stroke: "url(#paint3_linear_503_469)",
    strokeWidth: 0.4,
    mask: "url(#path-2-outside-2_503_469)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-3_503_469",
    maskUnits: "userSpaceOnUse",
    x: 8.14062,
    y: 9.88184,
    width: 3,
    height: 3,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 8.14062,
    y: 9.88184,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0397 10.8818C9.54403 10.8818 9.14062 11.2856 9.14062 11.7809C9.14062 12.2761 9.54444 12.6799 10.0397 12.6799C10.5357 12.6799 10.9395 12.2761 10.9395 11.7809C10.9395 11.2856 10.5361 10.8818 10.0397 10.8818Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.0397 10.8818C9.54403 10.8818 9.14062 11.2856 9.14062 11.7809C9.14062 12.2761 9.54444 12.6799 10.0397 12.6799C10.5357 12.6799 10.9395 12.2761 10.9395 11.7809C10.9395 11.2856 10.5361 10.8818 10.0397 10.8818Z",
    fill: "url(#paint4_linear_503_469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0397 10.8818C9.54403 10.8818 9.14062 11.2856 9.14062 11.7809C9.14062 12.2761 9.54444 12.6799 10.0397 12.6799C10.5357 12.6799 10.9395 12.2761 10.9395 11.7809C10.9395 11.2856 10.5361 10.8818 10.0397 10.8818Z",
    stroke: "url(#paint5_linear_503_469)",
    strokeWidth: 0.4,
    mask: "url(#path-3-outside-3_503_469)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-4_503_469",
    maskUnits: "userSpaceOnUse",
    x: 11.1006,
    y: 9.88184,
    width: 3,
    height: 3,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 11.1006,
    y: 9.88184,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9996 10.8818C12.504 10.8818 12.1006 11.2856 12.1006 11.7809C12.1006 12.2761 12.5044 12.6799 12.9996 12.6799C13.4961 12.6799 13.8995 12.2761 13.8995 11.7809C13.8995 11.2856 13.4961 10.8818 12.9996 10.8818Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.9996 10.8818C12.504 10.8818 12.1006 11.2856 12.1006 11.7809C12.1006 12.2761 12.5044 12.6799 12.9996 12.6799C13.4961 12.6799 13.8995 12.2761 13.8995 11.7809C13.8995 11.2856 13.4961 10.8818 12.9996 10.8818Z",
    fill: "url(#paint6_linear_503_469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9996 10.8818C12.504 10.8818 12.1006 11.2856 12.1006 11.7809C12.1006 12.2761 12.5044 12.6799 12.9996 12.6799C13.4961 12.6799 13.8995 12.2761 13.8995 11.7809C13.8995 11.2856 13.4961 10.8818 12.9996 10.8818Z",
    stroke: "url(#paint7_linear_503_469)",
    strokeWidth: 0.4,
    mask: "url(#path-4-outside-4_503_469)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-5_503_469",
    maskUnits: "userSpaceOnUse",
    x: 14.0605,
    y: 9.88184,
    width: 3,
    height: 3,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 14.0605,
    y: 9.88184,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9596 10.8818C15.464 10.8818 15.0605 11.2856 15.0605 11.7809C15.0605 12.2761 15.4644 12.6799 15.9596 12.6799C16.4556 12.6799 16.8594 12.2761 16.8594 11.7809C16.8594 11.2856 16.4556 10.8818 15.9596 10.8818Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.9596 10.8818C15.464 10.8818 15.0605 11.2856 15.0605 11.7809C15.0605 12.2761 15.4644 12.6799 15.9596 12.6799C16.4556 12.6799 16.8594 12.2761 16.8594 11.7809C16.8594 11.2856 16.4556 10.8818 15.9596 10.8818Z",
    fill: "url(#paint8_linear_503_469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9596 10.8818C15.464 10.8818 15.0605 11.2856 15.0605 11.7809C15.0605 12.2761 15.4644 12.6799 15.9596 12.6799C16.4556 12.6799 16.8594 12.2761 16.8594 11.7809C16.8594 11.2856 16.4556 10.8818 15.9596 10.8818Z",
    stroke: "url(#paint9_linear_503_469)",
    strokeWidth: 0.4,
    mask: "url(#path-5-outside-5_503_469)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_503_469",
    x1: 0.26123,
    y1: 12.9996,
    x2: 25.7388,
    y2: 12.9996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_503_469",
    x1: 0.26123,
    y1: 12.9996,
    x2: 25.7388,
    y2: 12.9996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_503_469",
    x1: 6.47217,
    y1: 13.0002,
    x2: 19.5282,
    y2: 13.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_503_469",
    x1: 6.47217,
    y1: 13.0002,
    x2: 19.5282,
    y2: 13.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_503_469",
    x1: 9.14063,
    y1: 11.7809,
    x2: 10.9395,
    y2: 11.7809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_503_469",
    x1: 9.14063,
    y1: 11.7809,
    x2: 10.9395,
    y2: 11.7809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_503_469",
    x1: 12.1006,
    y1: 11.7809,
    x2: 13.8995,
    y2: 11.7809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_503_469",
    x1: 12.1006,
    y1: 11.7809,
    x2: 13.8995,
    y2: 11.7809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_503_469",
    x1: 15.0605,
    y1: 11.7809,
    x2: 16.8594,
    y2: 11.7809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_503_469",
    x1: 15.0605,
    y1: 11.7809,
    x2: 16.8594,
    y2: 11.7809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/customer_support.c126a510aac5c24e8dde1824bce2435f.svg";
export { ForwardRef as ReactComponent };